import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/base.jpg'


const _hoisted_1 = { class: "output-image" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "base-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "overlay-image" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { IProduct } from '@/model/Product'
import { PropType, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  lame: { type: Object as PropType<IProduct | undefined>, default: () => undefined }
},
  setup(__props) {

const props = __props



const imageAppear = [
  { opacity: '0' },
  { opacity: '1' }
];

const imageTiming = {
  duration: 1000,
  iterations: 1,
}

watch(() => props.lame, () => {
  const img = new Image()
  const url = `https://www.bardagefacile.fr/images/simulateur/${props.lame?.photosim}`
  const container = document.getElementById('overlay-image') as HTMLDivElement

  const imageElement = container.querySelector('img')

  if (imageElement?.src === url) return
  if (imageElement) {
    imageElement.style.transition = 'opacity 1s'
    imageElement.style.opacity = '0'
  }

  img.onload = () => {
    container.replaceChildren(img)
    container.animate(imageAppear, imageTiming)
  }
  img.src = url
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})